import { apiEmployeeToday } from "@/api/employees/employee-today.api.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

export const employeeTodayKeys = createQueryKeys("employeeToday", {
  getToday: () => ({
    queryKey: ["all"],
    queryFn: async () => {
      const result = await apiEmployeeToday.getToday();
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
});

export const useEmployeeToday = () => {
  return useQuery({
    ...employeeTodayKeys.getToday(),
    staleTime: 60 * 1000,
  });
};
